import { createFileRoute } from '@tanstack/react-router';

import { WorkspaceChatListScreen } from '@/features/chat/components/workspace/ChatListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/chats/')({
  beforeLoad: () => {
    requirePermission('admin_list:read');
  },
  component: WorkspaceChatListScreen,
  staticData: { crumb: 'Chats' },
});
